import React, { useState } from "react"
// import '../assets/scss/pages/one-zone.scss'

import { ERoutes } from "../../types"
import { getRoute, getRoutesByGroupId } from "../../helpers"

import DefaultLayout from "../../layouts/DefaultLayout"

const Onezone: React.FC<any> = (props) => {

	const [route] = useState(getRoute(ERoutes.OneZone))
	const [parent] = useState(getRoute(ERoutes.Makeup))
	const [navGroups] = useState(parent?.navGroups?.map(group => {
		return { ...group, routes: getRoutesByGroupId(group.id) }
	}))

	return (
		<DefaultLayout
			{...props}
			route={route}
			navGroups={navGroups}
			title='会員募集｜第2750地区東京中央ロータリークラブ'
		>
			<div className='one-zone'>
				Onezone
			</div>
		</DefaultLayout>
	)
}

export default Onezone
